import * as React from 'react';

import Illustration, { IllustrationColorProps } from './Illustration';

export const IllustrationTakeout: React.FunctionComponent<IllustrationColorProps> = ({ color }) => {
  return (
    <Illustration
      color={color}
      strokes={
        <>
          <path d="M32.6586 27.0732V16.2507H53.9123V49.4767H49.7073" />
          <path d="M38.8157 13.9987C38.8157 11.2378 41.0675 9 43.8458 9C46.624 9 48.8758 11.2378 48.8758 13.9987" />
          <path d="M36.209 18.4724V25.3533H45.7189V20.1371" />
          <path d="M9.46486 39.5623H51.5097" />
          <path d="M10.5158 37.8049L12.3416 31.7565C12.6842 30.6229 13.7334 29.8466 14.9244 29.8466H40.8289" />
          <path d="M44.8172 29.8466H46.3892C47.4438 29.8466 48.3819 30.5141 48.7209 31.5069L50.6229 37.075" />
          <path d="M12.6514 41.1202L15.5875 49.4768H29.936" />
          <path d="M36.209 49.4768H45.8181L48.6214 41.1202" />
          <path d="M14.1202 35.3515H18.7028C19.2821 35.3515 19.7511 35.8176 19.7511 36.3933V37.805" />
          <path d="M14.1202 37.805H18.1746" />
        </>
      }
      shadows={
        <>
          <path d="M36.1794 25.1673L36.0125 16.285H32.6363V29.82H38.5446H46.1409L48.251 30.6659L50.7831 37.0105L51.6271 39.5483H49.0935L45.7524 49.6996H53.7372L54.1592 37.8564V35.7416C54.1592 35.7416 52.8932 31.0889 50.7831 28.1281C48.673 25.1673 46.9849 25.1673 46.9849 25.1673H43.6088H36.1794Z" />
          <path d="M18.7097 35.3186H14.0675V37.8565H19.9758V36.0437L18.7097 35.3186Z" />
          <path d="M47.2427 39.5483H12.079L13.1789 43.355H45.9851L47.2427 39.5483Z" />
          <path d="M8.15923 51.3915C8.15923 50.4571 8.91671 49.6996 9.85111 49.6996H49.517V53.0833H9.85111C8.91671 53.0833 8.15923 52.3259 8.15923 51.3915Z" />
        </>
      }
      dots={
        <>
          <circle cx="39.4446" cy="22.6836" r="0.9" />
          <circle cx="39.4446" cy="19.2998" r="0.9" />
          <circle cx="42.8207" cy="19.2998" r="0.9" />
          <circle cx="42.8207" cy="22.6836" r="0.9" />
          <circle cx="25.94" cy="24.3754" r="0.9" />
          <circle cx="25.0959" cy="20.9917" r="0.9" />
          <circle cx="28.4721" cy="26.9132" r="0.9" />
          <circle cx="23.4079" cy="26.9132" r="0.9" />
          <circle cx="21.7198" cy="23.5295" r="0.9" />
          <circle cx="18.3436" cy="26.0673" r="0.9" />
          <circle cx="21.7198" cy="19.2998" r="0.9" />
          <circle cx="29.3161" cy="21.8376" r="0.9" />
          <circle cx="18.3436" cy="21.8376" r="0.9" />
        </>
      }
    />
  );
};

export default IllustrationTakeout;
